

import { BrowserRouter, Navigate, Route, Router, Routes } from 'react-router-dom';


import React, { Fragment, useContext } from 'react';
import HomePsico from '../views/psicologo/home_psico';
import CitaSinglePsico from '../views/psicologo/cita_single_psico';
import HomeClient from '../views/client/home_client';

import LoginView from '../views/commun/login_view';
import { AuthContext } from '../context/auth_context';
import DashboardClient from '../views/client/dashboard_client';
import FamiliaClient from '../views/client/familia_client';
import PerfilClient from '../views/client/perfil_client';
import TipsClient from '../views/client/tips_client';
import DocumentosClient from '../views/client/documentos_client';
import PreciosClient from '../views/client/precios_cliente';

import HomeAdmin from '../views/admin/home_admin';
import CalendarioAdmin from '../views/admin/calendario_admin';
import EspecialistasAdmin from '../views/admin/especialistas_admin';
import ValoracionesAdmin from '../views/admin/valoraciones_admin';
import CitasAdmin from '../views/admin/citas_admin';
import CitaSingleAdmin from '../views/admin/cita_single_admin';
import TipsAdmin from '../views/admin/tips_admin';
import DocumentosAdmin from '../views/admin/documents_admin';
import TagsAdmin from '../views/admin/tags_admin';


function AdminNavigator() {
  return (
  
    <PrivateRoute>
        <Routes>
            <Route exact path="/" element={<HomeAdmin></HomeAdmin>} />
            <Route exact path="/citas" element={<CitasAdmin></CitasAdmin>} />
            <Route exact path="/cita/:cita_id" element={<CitaSingleAdmin></CitaSingleAdmin>} />
            <Route exact path="/calendario" element={<CalendarioAdmin></CalendarioAdmin>} />
            <Route exact path="/especialistas" element={<EspecialistasAdmin></EspecialistasAdmin>} />
            <Route exact path="/valoraciones" element={<ValoracionesAdmin></ValoracionesAdmin>} />
            <Route exact path="/tips" element={<TipsAdmin></TipsAdmin>} />
            <Route exact path="/documentos" element={<DocumentosAdmin></DocumentosAdmin>} />
            <Route exact path="/tags" element={<TagsAdmin></TagsAdmin>} />
        </Routes>  
    </PrivateRoute>
    
  );
}



function PrivateRoute({ children }) {
  
    const { user } = useContext(AuthContext);
  
    console.log(user)

    return user.roles?.includes("Admin") ? children : <Navigate to="/" />;
}


export default AdminNavigator;
